// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SidebarContainer_side-container__uO03b {
  width: 35vw;
  background: var(--m-sidebar-background-color);
  height: calc(100% - 70px);
  position: fixed;
  top: 70px;
  bottom: 0;
  right: 0;
  /* Above page content / tables (fixed + no z-index was painted under later siblings) */
  z-index: 30;
  box-shadow: var(--m-box-shadow);
  padding: 20px;
  overflow-y: auto;
  transform: translateX(35vw);
  transition: transform 0.4s ease-in-out;
  border-left: 1px solid var(--m-border-color);
  color: var(--m-text);
}
.SidebarContainer_side-container--title__5-19p {
  font-size: 16px;
  font-weight: 500;
}
.SidebarContainer_side-container--opened__FpBdG {
  transform: translateX(0);
}

@media (max-width: 768px) {
  .SidebarContainer_side-container__uO03b {
    width: 100vw;
    transform: translateX(100%);
  }
  .SidebarContainer_side-container--opened__FpBdG {
    transform: translateX(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/SidebarContainer/SidebarContainer.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,6CAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;EACA,SAAA;EACA,QAAA;EACA,sFAAA;EACA,WAAA;EACA,+BAAA;EACA,aAAA;EACA,gBAAA;EACA,2BAAA;EACA,sCAAA;EACA,4CAAA;EACA,oBAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;AACJ;AAEE;EACE,wBAAA;AAAJ;;AAKA;EACE;IACE,YAAA;IACA,2BAAA;EAFF;EAIE;IACE,wBAAA;EAFJ;AACF","sourcesContent":[".side-container {\n  width: 35vw;\n  background: var(--m-sidebar-background-color);\n  height: calc(100% - 70px);\n  position: fixed;\n  top: 70px;\n  bottom: 0;\n  right: 0;\n  /* Above page content / tables (fixed + no z-index was painted under later siblings) */\n  z-index: 30;\n  box-shadow: var(--m-box-shadow);\n  padding: 20px;\n  overflow-y: auto;\n  transform: translateX(35vw);\n  transition: transform 0.4s ease-in-out;\n  border-left: 1px solid var(--m-border-color);\n  color: var(--m-text);\n\n  &--title {\n    font-size: 16px;\n    font-weight: 500;\n  }\n\n  &--opened {\n    transform: translateX(0);\n    // overflow-y: hidden;\n  }\n}\n\n@media (max-width: 768px) {\n  .side-container {\n    width: 100vw;\n    transform: translateX(100%);\n\n    &--opened {\n      transform: translateX(0);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"side-container": `SidebarContainer_side-container__uO03b`,
	"side-container--title": `SidebarContainer_side-container--title__5-19p`,
	"side-container--opened": `SidebarContainer_side-container--opened__FpBdG`
};
export default ___CSS_LOADER_EXPORT___;
